import type { AclFlag } from '@openx/types/session.ts';

type SingleCharDecompressed = [AclFlag, AclFlag, AclFlag, AclFlag];

// char represents 0-9a-f string
function decompressSingleChar(char: string): SingleCharDecompressed {
  const decimalCode: number = parseInt(char, 16); // f.e. decimalCode = 15
  const binaryCode: string = decimalCode.toString(2).padStart(4, '0'); // f.e. binaryCode = '1111'

  return Array.from(binaryCode).reverse().map(Number) as SingleCharDecompressed;
}

/*
  compressed acl in format: a112356ff...
 */
export function unpackAcl(compressedAcl: string): AclFlag[] {
  if (!compressedAcl) {
    return [];
  }
  return ([] as AclFlag[]).concat(...Array.from(compressedAcl).map(decompressSingleChar));
}
